import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { collectionServices } from '@hero/services';

export const useDeleteCollection = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(id => collectionServices.delete(id), {
    ...options,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetCollectionsKey] });
      options.onSuccess && options.onSuccess();
    }
  });
};
